import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import i18n from '../_helpers/i18n'
import { ITranslationState } from '../_models/translationInterface'
import translationService from '../_services/translationService'
import { RootState } from '../_store/store'
import translatedJson from '../translation/translation.json'
import { startLoader, stopLoader } from './loaderSlice'

const initialState: ITranslationState = {
  loader: false,
  translatedData: {
    translations: translatedJson,
    language: 'en',
  },
  languages: [],
  selectedLanguage: 'en',
}

export const translation = createAsyncThunk(
  '/translation',
  async (language: string, { dispatch }) => {
    dispatch(startLoader())
    const res = await translationService.translated(language)
    const { data } = res

    const lang = data.language
    const translations = data.translations

    // Set i18n resource bundle before returning the payload
    i18n.addResourceBundle(lang, 'translation', translations, true, true)
    await i18n.reloadResources()
    // Save preferred language to sessionStorage
    sessionStorage.setItem('preferredLanguage', lang)
    // await i18n.changeLanguage(language)
    dispatch(stopLoader())
    return res
  },
)

export const getLanguages = createAsyncThunk('/getLanguages', async () => {
  const res = await translationService.getLanguages()
  return res
})
export const setCommonLanguage = createAsyncThunk(
  '/setCommonLanguage',
  async (language: string) => {
    const res = await translationService.setCommonLanguage(language)
    return res
  },
)

const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      return {
        ...state,
        selectedLanguage: action.payload,
      }
    },
    resetSelectedLanguage: (state) => {
      state.selectedLanguage = initialState.selectedLanguage
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(translation.pending, (state) => {
        state.loader = true
      })
      .addCase(translation.fulfilled, (state, action) => {
        state.loader = true
        state.translatedData = action?.payload?.data
        state.selectedLanguage = action?.payload?.data?.language

        // // Add new translation bundle
        // i18n.addResourceBundle(action?.payload?.data?.language, 'translation', translations, true, true)
        i18n.changeLanguage(action?.payload?.data?.language)
      })
      .addCase(translation.rejected, (state) => {
        state.loader = true
      })
      .addCase(getLanguages.fulfilled, (state, action) => {
        state.languages = action.payload.data.language_list
      })
  },
})
export const { setLanguage, resetSelectedLanguage } = translationSlice.actions
export const translationData = (state: RootState) => state.translation
export default translationSlice.reducer
